<template>
  <DialogTemplate>
    <div
      class="pt-2"
      style="max-width: 420px"
    >
      <div>
        <div class="f-align-center pb-1 weight_700">
          <v-icon class="mr-2">mdi-filter-outline</v-icon>
          {{ $t('tips.study.filter.in_any') }}
        </div>

        <div class="ml-8">
          {{ $t('tips.study.filter.in_any_explanation') }}
        </div>

        <div class="f-align-center pb-1 weight_700 mt-8">
          <v-icon class="mr-2">mdi-filter</v-icon>

          {{ $t('tips.study.filter.in_all') }}
        </div>

        <div class="ml-8">
          {{ $t('tips.study.filter.in_all_explanation') }}
        </div>
      </div>

      <img
        class="mt-4 w-100"
        :src="getImage('in_any_example')"
        style="border-radius: 8px"
      />
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'StudyFilterHelpDialog',

  components: {
    DialogTemplate,
  },
  data() {
    return {}
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/img/${img}.webp`, import.meta.url).href
    },
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
  },
}
</script>
